import { useMutation } from "@tanstack/react-query";

import { usersKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useDeleteUser(userId: number | undefined) {
  return useMutation({
    mutationFn: async () =>
      await apiClient.url(`/users/${userId}`).delete().json(),
    mutationKey: usersKeys.delete(userId),
  });
}
